import { trackWithGoogleAnalytics } from '../shared/trackers/trackWithGoogleAnalytics';
import { useStores } from '../../../app/root/domain/stores/useStores';
import { useEffect } from 'react';
import { useAuthStore } from '../../../auth/shared/store/useAuthStore';

export const setUserLoginStatusProperty = (isAuthenticated: boolean) => {
	trackWithGoogleAnalytics('set', 'user_properties', {
		login_status: isAuthenticated,
	});
};

export const useSetUserProperties = async () => {
	const { getVehicleStore } = useStores();
	const { isAuthenticated } = useAuthStore();

	useEffect(() => {
		setUserLoginStatusProperty(isAuthenticated);

		if (isAuthenticated) {
			getVehicleStore.load();
		}
	}, [isAuthenticated]);
};
